import { Extension } from "@tiptap/core";
import type { Node } from "@tiptap/pm/model";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";

const emptySectionVisibilityKey = new PluginKey("emptySectionVisibility");

function hasEntry(node: Node): boolean {
  if (node.isText) return Boolean(node.text?.trim());
  if (node.isLeaf) return node.type.name !== "hardBreak";
  let found = false;
  node.forEach((child) => { found ||= hasEntry(child); });
  return found;
}

// Decorations affect display only: hidden sections remain in saves and live updates.
export default Extension.create({
  name: "hideEmptySections",
  addProseMirrorPlugins() {
    return [new Plugin({
      key: emptySectionVisibilityKey,
      props: {
        decorations(state) {
          const decorations: Decoration[] = [];
          let section: { node: Node; pos: number }[] = [];
          const finish = () => {
            if (section.length && !section.slice(1).some(({ node }) => hasEntry(node))) {
              for (const { node, pos } of section) {
                decorations.push(Decoration.node(pos, pos + node.nodeSize, {
                  style: "display: none;",
                  "data-empty-section": "true",
                }));
              }
            }
          };
          state.doc.forEach((node, pos) => {
            if (node.type.name === "heading" && node.attrs.level <= 2) {
              finish();
              section = [{ node, pos }];
            } else if (section.length) {
              section.push({ node, pos });
            }
          });
          finish();
          return DecorationSet.create(state.doc, decorations);
        },
      },
    })];
  },
});
